import { z } from 'zod';

/** Commands used by Phase 4 spread sessions (§20–§25). */

export const createSpreadSessionSchema = z.object({
  mode: z.enum(['solo', 'group']),
  title: z.string().trim().min(2).max(120).nullable().optional(),
});
export type CreateSpreadSessionInput = z.infer<typeof createSpreadSessionSchema>;

export const drawSpreadCardSchema = z.object({
  /** Required for a preset spread; rejected for a free-form spread. */
  positionId: z.string().min(1).optional(),
  /** Required for a free-form spread; the preset derives it from its position. */
  deckId: z.string().min(1).optional(),
  /** Percentage coordinates on the responsive working table. */
  x: z.number().int().min(0).max(100).default(50),
  y: z.number().int().min(0).max(100).default(50),
  /**
   * Чей расклад заполняет ведущий. Участник за другого не тянет — гостевой
   * маршрут это поле игнорирует; ведущий тянет в расклад того, кого выбрал.
   */
  forParticipantId: z.string().min(1).optional(),
});
export type DrawSpreadCardInput = z.infer<typeof drawSpreadCardSchema>;

/** Ведущий отменяет последнюю карту выбранного участника. */
export const undoSpreadCardSchema = z.object({
  participantId: z.string().min(1),
});
export type UndoSpreadCardInput = z.infer<typeof undoSpreadCardSchema>;

export const moveSpreadCardSchema = z
  .object({
    x: z.number().int().min(0).max(100).optional(),
    y: z.number().int().min(0).max(100).optional(),
    zIndex: z.number().int().min(0).max(10_000).optional(),
  })
  .refine((value) => value.x !== undefined || value.y !== undefined || value.zIndex !== undefined, {
    message: 'Укажите новое положение карты',
  });
export type MoveSpreadCardInput = z.infer<typeof moveSpreadCardSchema>;

/** SPR-14 — открыть или закрыть подключение по ссылке. */
export const setEntryOpenSchema = z.object({
  open: z.boolean(),
});
export type SetEntryOpenInput = z.infer<typeof setEntryOpenSchema>;

/**
 * Кто сейчас тянет карту (§бэклог 9).
 *
 * `null` — свободный порядок: тянут все. Отдельного «выключить очередь» не
 * нужно, это то же самое действие с пустым значением.
 */
export const setSpreadTurnSchema = z.object({
  participantId: z.string().min(1).nullable(),
});
export type SetSpreadTurnInput = z.infer<typeof setSpreadTurnSchema>;
